import { Component } from '@angular/core';

@Component({
  selector: 'wun-addresses',
  imports: [],
  templateUrl: './addresses.component.html',
  styleUrl: './addresses.component.scss'
})
export class AddressesComponent {

}
